import { render, staticRenderFns } from "./sendConfig.vue?vue&type=template&id=59b84f00&scoped=true"
import script from "./sendConfig.vue?vue&type=script&lang=js"
export * from "./sendConfig.vue?vue&type=script&lang=js"
import style0 from "./sendConfig.vue?vue&type=style&index=0&id=59b84f00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b84f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b84f00')) {
      api.createRecord('59b84f00', component.options)
    } else {
      api.reload('59b84f00', component.options)
    }
    module.hot.accept("./sendConfig.vue?vue&type=template&id=59b84f00&scoped=true", function () {
      api.rerender('59b84f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/children/sendConfig.vue"
export default component.exports